import {Component, Input, OnInit} from '@angular/core';
import {Notification} from '@models/data/notifications/Notification';
import {NotificationItemType} from '@models/data/notifications/enums/NotificationItemType';
import { IconComponent } from '../../../../components/icon/icon.component';


@Component({
    selector: 'app-notification-small',
    templateUrl: './notification-small.component.html',
    styleUrls: ['./notification-small.component.scss'],
    standalone: true,
    imports: [IconComponent]
})
export class NotificationSmallComponent implements OnInit {
  @Input() notification: Notification = null;
  notificationItemType = NotificationItemType;

  constructor() {
  }

  ngOnInit(): void {
  }

}
